// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

// ✅ Export the config for use in secondary Firebase app initialization
export const firebaseConfig = {
  apiKey: "AIzaSyDAX7wDfb1LGRgOLfs20yJ0pryU9zv812o",
  authDomain: "gizmo-7cbee.firebaseapp.com",
  projectId: "gizmo-7cbee",
  storageBucket: "gizmo-7cbee.appspot.com",
  messagingSenderId: "828333429997",
  appId: "1:828333429997:web:6900dc974ba6c715ff28e4",
  measurementId: "G-9NXH42JDSE"
};

// Initialize the default Firebase app
const app = initializeApp(firebaseConfig);

// Initialize core services
const analytics = getAnalytics(app);
const auth = getAuth(app);
const storage = getStorage(app);
const db = getFirestore(app);

// ✅ Export all initialized services for use across your app
export { app, auth, analytics, storage, db };
